/**
 * Created by vladzur on 04-07-16.
 */
import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'
import DatesResource from '../api/dates'
import Player from '../api/player'
import Award from '../api/award'

Vue.use(VueResource)

export const setError = ({dispatch}, value) => {
  dispatch('SET_ERROR', value)
}

export const setChampionship = ({dispatch}, championship) => {
  dispatch('SET_CHAMPIONSHIP', championship)
}

export const setRegistrations = ({dispatch}, value) => {
  dispatch('SET_REGISTRATIONS', value)
}

export const setDate = ({dispatch, state}, date) => {
  let PlayerAPI = new Player()
  dispatch('SET_DATE', date)
  let players = []
  let playersActive = []
  state.registrations.forEach((s) => {
    /*
    if (s.status >= 3) {
      let player = s
      players.push(player)
    }
    if (s.status >= 3) {
      playersActive.push(s)
    }*/
    let player = s
    players.push(player)
    playersActive.push(s)
  })
  let playersWaiting = state.players_waiting
  let playersReady = state.players_ready
  if (playersReady[date.id] == undefined) {
    playersReady = PlayerAPI.playersReady(players)
  }
  if (playersWaiting[date.id] == undefined) {
    if (playersReady[date.id] != undefined) {
      playersWaiting[date.id] = PlayerAPI.playersWaiting(date.id, playersReady, players)
    } else {
      playersWaiting[date.id] = playersActive
    }
  }
  dispatch('SET_PLAYERS_READY', playersReady)
  dispatch('SET_PLAYERS_WAITING', playersWaiting)
}

export const setCourse = ({dispatch}, value) => {
  dispatch('SET_COURSE', value)
  let holesOut = []
  let holesIn = []
  let holes = []
  if (value.holes != undefined) {
    holes = value.holes
  }
  holes.forEach(h => {
    let id = 'h' + h.number
    let hole = {
      id: id,
      par: h.par,
      value: null
    }
    if (h.number < 10) {
      holesOut.push(hole)
    } else {
      holesIn.push(hole)
    }
  })
  dispatch('SET_HOLES_IN', holesIn)
  dispatch('SET_HOLES_OUT', holesOut)
}

export const setPlayer = ({dispatch}, value) => {
  dispatch('SET_PLAYER', value)
}

export const setLoading = ({dispatch}, value) => {
  dispatch('SET_LOADING', value)
}

export const setCard = ({dispatch}, value) => {
  dispatch('SET_CARD', value)
}

export const resetCard = ({dispatch}) => {
  let card = {
    id: null,
    registration_id: null,
    date_id: null,
    h1: null,
    h2: null,
    h3: null,
    h4: null,
    h5: null,
    h6: null,
    h7: null,
    h8: null,
    h9: null,
    h10: null,
    h11: null,
    h12: null,
    h13: null,
    h14: null,
    h15: null,
    h16: null,
    h17: null,
    h18: null
  }
  dispatch('SET_CARD', card)
}

export const setHolesIn = ({dispatch}, value) => {
  dispatch('SET_HOLES_IN', value)
}

export const setHolesOut = ({dispatch}, value) => {
  dispatch('SET_HOLES_OUT', value)
}

export const setPlayersWaiting = ({dispatch}, players) => {
  dispatch('SET_PLAYERS_WAITING', players)
}

export const setPlayersReady = ({dispatch}, players) => {
  dispatch('SET_PLAYERS_READY', players)
}

export const setCardSaved = ({dispatch}, value) => {
  dispatch('SET_CARD_SAVED', value)
}

export const addPlayerToReady = ({dispatch, state}, player) => {
  let date = state.current_date
  let playersWaiting = state.players_waiting
  let playersReady = state.players_ready
  if (playersReady[date.id] == undefined) {
    playersReady[date.id] = []
  }
  let playersReadySub = playersReady[date.id]
  let playersWaitingSub = playersWaiting[date.id]
  playersReadySub.push(player)
  playersReady.$set(date.id, playersReadySub)
  playersWaitingSub.$remove(player)
  playersWaiting.$set(date.id, playersWaitingSub)
  if (playersWaiting[date.id].length < 1) {
    date.finished = true
    dispatch('SET_DATE', date)
    DatesResource.put(state.current_date)
  }
  dispatch('SET_PLAYERS_READY', playersReady)
  dispatch('SET_PLAYERS_WAITING', playersWaiting)
}

export const setPlayerCards = ({dispatch, state}, player) => {
  dispatch('SET_LOADING', true)
  Vue.http.get(
    configure.api_url + 'registrations/' + player.id
  ).then(response => {
    dispatch('SET_PLAYER_CARDS', response.data.cards)
    dispatch('SET_LOADING', false)
    dispatch('SET_SHOW_PLAYER_CARDS', true)
  }, error => {
    dispatch('SET_LOADING', false)
    return error
  })
}

export const showPlayerCards = ({dispatch}, value) => {
  dispatch('SET_SHOW_PLAYER_CARDS', value)
}

export const showPlayer = ({dispatch}, value) => {
  dispatch('SET_SHOW_PLAYER', value)
}

export const showCard = ({dispatch}, value) => {
  dispatch('SET_SHOW_CARD', value)
}

export const setConfigCategories = ({dispatch}, value) => {
  dispatch('SET_CONFIG_CATEGORIES', value)
}

export const setConfigCategory = ({dispatch}, value) => {
  dispatch('SET_CONFIG_CATEGORY', value)
}

export const setConfigPlayer = ({dispatch}, value) => {
  dispatch('SET_CONFIG_PLAYER', value)
}

export const setConfigChampionship = ({dispatch}, value) => {
  dispatch('SET_CONFIG_CHAMPIONSHIP', value)
}

export const setConfigDates = ({dispatch}, value) => {
  dispatch('SET_CONFIG_DATES', value)
}

export const setConfigCourses = ({dispatch}, value) => {
  dispatch('SET_CONFIG_COURSES', value)
}

export const setConfigRegistrations = ({dispatch}, value) => {
  dispatch('SET_CONFIG_REGISTRATIONS', value)
}

export const loadConfigRegistrations = ({dispatch, state}) => {
  dispatch('SET_LOADING', true)
  let championshipId = state.configuration.championship.id
  Vue.http.get(
    configure.api_url + 'registrations?championship_id=' + championshipId
  ).then((response) => {
    dispatch('SET_CONFIG_REGISTRATIONS', response.data)
    dispatch('SET_LOADING', false)
  }, (error) => {
    dispatch('SET_LOADING', false)
    return error
  })
}

export const resetHoles = ({dispatch, state}) => {
  let holesOut = [
    {id: 'h1', par: 0, value: null, handicap: null},
    {id: 'h2', par: 0, value: null, handicap: null},
    {id: 'h3', par: 0, value: null, handicap: null},
    {id: 'h4', par: 0, value: null, handicap: null},
    {id: 'h5', par: 0, value: null, handicap: null},
    {id: 'h6', par: 0, value: null, handicap: null},
    {id: 'h7', par: 0, value: null, handicap: null},
    {id: 'h8', par: 0, value: null, handicap: null},
    {id: 'h9', par: 0, value: null, handicap: null}
  ]
  let holesIn = [
    {id: 'h10', par: 0, value: null, handicap: null},
    {id: 'h11', par: 0, value: null, handicap: null},
    {id: 'h12', par: 0, value: null, handicap: null},
    {id: 'h13', par: 0, value: null, handicap: null},
    {id: 'h14', par: 0, value: null, handicap: null},
    {id: 'h15', par: 0, value: null, handicap: null},
    {id: 'h16', par: 0, value: null, handicap: null},
    {id: 'h17', par: 0, value: null, handicap: null},
    {id: 'h18', par: 0, value: null, handicap: null}
  ]
  dispatch('SET_HOLES_IN', holesIn)
  dispatch('SET_HOLES_OUT', holesOut)
}

export const initHoles = ({dispatch, state}) => {
  let holesOut = []
  let holesIn = []
  state.current_course.holes.forEach((h) => {
    let id = 'h' + h.number
    let hole = {
      id: id,
      par: h.par,
      value: null,
      handicap: h.handicap
    }
    if (h.number < 10) {
      holesOut.push(hole)
    } else {
      holesIn.push(hole)
    }
  })
  dispatch('SET_HOLES_IN', holesIn)
  dispatch('SET_HOLES_OUT', holesOut)
}

export const updatePlayer = ({dispatch, state}, player, status) => {
  let PlayerAPI = new Player()
  let players = state.registrations
  let index = players.indexOf(player)
  player.status = status
  PlayerAPI.update(player)
  players.$set(index, player)
  dispatch('SET_REGISTRATIONS', players)
}

export const setConfigTeams = ({dispatch}, teams) => {
  dispatch('SET_CONFIG_TEAMS', teams)
}

export const setConfigTeam = ({dispatch}, team) => {
  dispatch('SET_CONFIG_TEAM', team)
}

export const addConfigTeam = ({dispatch, state}, team) => {
  let teams = state.configuration.teams
  teams.push(team)
  dispatch('SET_CONFIG_TEAMS', teams)
}

export const removeConfigTeam = ({dispatch, state}, team) => {
  let teams = state.configuration.teams
  teams.$remove(team)
  dispatch('SET_CONFIG_TEAMS', teams)
}

export const fetchConfigAwards = ({dispatch}) => {
  dispatch('SET_LOADING', true)
  let AwardApi = new Award()
  let awards = []
  AwardApi.fetch().then(response => {
    awards = response.data
    dispatch('SET_CONFIG_AWARDS', awards)
    dispatch('SET_LOADING', false)
  }, error => {
    dispatch('SET_LOADING', false)
    dispatch('SET_ERROR', 'Error fetching awards ' + error.message)
  })
}

export const addAward = ({dispatch, state}, award) => {
  dispatch('SET_LOADING', true)
  let AwardApi = new Award()
  AwardApi.post(award).then(response => {
    dispatch('SET_CONFIG_AWARD', response.data)
    dispatch('SET_LOADING', false)
  }, error => {
    dispatch('SET_LOADING', false)
    dispatch('SET_ERROR', 'Error saving award ' + error.message)
  })
}



/** WEBPACK FOOTER **
 ** ./src/vuex/actions.js
 **/